"use client";

import React, { useEffect, useState } from "react";
import BigTips from "@/Master/BigTips";
import { Button } from "../../_components";
import styles from "./AccountSelectionDialog.module.css";
import { SDialogFC, SDialogProps } from "@/Master/SDialogFC/SDialogFC";
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";

export enum UserType {
    visitor = "visitor", // 游客
    normal = "normal" // 用户
}

// type LoginType = keyof typeof UserType;

interface AccountSelectionDialogProps extends SDialogProps {
    callToLogin?: (type:UserType) => void;
}

export const AccountSelectionDialogFC: React.FC<AccountSelectionDialogProps> = (props) => {
    const { fcKey, isOpen, callToLogin } = props;
    const [loginType, setLoginType] = useState<UserType>(UserType.visitor);

    const {openDialog, closeDialog } = useDialogMethods(fcKey);


    useEffect(() => {
        console.log("AccountSelectionDialog initialized");

        return () => {
            console.log("AccountSelectionDialog disposed");
        };
    }, []);

    /** 登录操作 */
    const onToLogin = (type: UserType) => {
        BigTips.showMsg("onToLogin");
        setLoginType(type);
        props.onClose?.();
        closeDialog();
        callToLogin?.(type);
    };

    if (!isOpen) return null;

    return (
        <SDialogFC
            fcKey={fcKey}
            isOpen={isOpen}
            mode="Full"
            title=""
        >
                <section className={`${styles.layer} center`}>
                <section className={`${styles.content}`}>
                    <div className={styles.panel}></div>
                    <img src="/img/account-selection/envelope.webp" style={{ width: "3.8rem" }} alt="" />
                    <div className={styles.title}>WELCOME</div>
                    <div className={styles.des}>Join now and try your luck!</div>
                    <Button
                        color="#0090FF"
                        style={{
                            width: "4.6rem",
                            height: "1.1rem",
                            fontWeight: 900,
                            fontSize: ".5rem",
                        }}
                        onClick={() => onToLogin(UserType.visitor)}
                    >
                        Start earn cash
                    </Button>
                    <div className={styles.panel2}></div>
                    <Button
                        color="#33D24A"
                        style={{
                            width: "6.5rem",
                            height: "1.1rem",
                            fontWeight: 900,
                        }}
                        onClick={() => onToLogin(UserType.normal)}
                    >
                        I've got an account
                    </Button>
                </section>
            </section>
        </SDialogFC>
    );
};
